<script setup lang="ts">
// isDecorative: the caller already shows its own loading text, so the spinner should add nothing
// for screen readers rather than a second "Loading".
const props = defineProps<{ isDecorative?: boolean }>();
</script>

<template>
  <div class="spinnerWrapper" :role="props.isDecorative ? undefined : 'status'" :aria-hidden="props.isDecorative || undefined">
    <!-- the four rings are one visual; screen readers get the single label below -->
    <v-progress-circular :size="100" rotate="90" indeterminate class="spinner spinnerLarge" aria-hidden="true" />
    <v-progress-circular :size="75" rotate="180" indeterminate class="spinner spinnerMedium" aria-hidden="true" />
    <v-progress-circular :size="50" rotate="270" indeterminate class="spinner spinnerSmall" aria-hidden="true" />
    <v-progress-circular :size="25" indeterminate class="spinner spinnerXSmall" aria-hidden="true" />
    <span v-if="!props.isDecorative" class="visually-hidden">{{ $t('Loading') }}</span>
  </div>
</template>

<style scoped lang="scss">
.spinnerWrapper {
  position: relative;
  width: 100px;
  height: 110px;
  text-align: center;
  margin-top: 35px;
  margin-left: auto;
  margin-right: auto;
  .spinner {
    position: absolute;
  }
  .spinnerLarge {
    top: 0;
    left: 0;
  }
  .spinnerMedium {
    width: 75px;
    height: 75px;
    top: 12.5px;
    left: 12.5px;
  }
  .spinnerSmall {
    width: 50px;
    height: 50px;
    top: 25px;
    left: 25px;
  }
  .spinnerXSmall {
    width: 25px;
    height: 25px;
    top: 37.5px;
    left: 37.5px;
  }
}
</style>
